import React from "react"
import { useScrollReveal } from "../utils"

export function OverviewBlock({ programme }) {
  const ref = useScrollReveal()
  const northStar = programme.measurement?.north_star

  return (
    <div ref={ref} style={{ padding: "80px 60px 0", maxWidth: 1000, boxSizing: "border-box" }}>
      <div style={{ borderTop: "1px solid rgba(255,255,255,0.12)", paddingTop: 60 }}>
        <p style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.08em", color: "#fff", margin: "0 0 28px" }}>
          Overview
        </p>
        {programme.description.split("\n\n").map((para, i, arr) => (
          <p key={i} style={{ fontSize: 18, lineHeight: 1.7, color: "#fff", maxWidth: 640, margin: i < arr.length - 1 ? "0 0 20px" : "0 0 20px" }}>
            {para}
          </p>
        ))}
        {northStar && (
          <p style={{ fontSize: 15, lineHeight: 1.7, color: "#fff", maxWidth: 600, margin: 0 }}>
            <span style={{ color: "#FF4000" }}>North star outcome:</span> {northStar.description}
          </p>
        )}
      </div>
    </div>
  )
}
